const BLUE_100 = "#9ca5b3"
const BLUE_200 = "#515c6d"
const BLUE_300 = "#38414E"
const BLUE_400 = "#2f3948"
const BLUE_500= "#242f3e"
const BLUE_600 = "#212a37"
const BLUE_700 = "#1f2835"
const BLUE_800 = "#17263c"
const BROWN_100 = "#746855"
const ORANGE_100 = "#f3d19c"
const ORANGE_200 = "#d59563"
const GREEN_100 = "#6b9a76"
const GREEN_200 = "#263c3f"

const geometry = BLUE_500
const labelStroke = BLUE_500
const labelFill = BROWN_100

const administrativeTextFill = ORANGE_200

const poiTextFill = ORANGE_200
const poiParkGeometry = GREEN_200
const poiParkTextFill = GREEN_100

const roadGeometry = BLUE_300
const roadGeometryStroke = BLUE_600
const roadTextFill = BLUE_100
const roadHighwayGeometry = BROWN_100
const roadHighwayGeometryStroke = BLUE_700
const roadHighwayTextFill = ORANGE_100

const transitGeometry = BLUE_400
const transitStationTextFill = ORANGE_200

const waterGeometry = BLUE_800
const waterTextFill = BLUE_200
const waterTextStroke = BLUE_800

export default [
  { elementType: "geometry", stylers: [{ color: geometry }] },
  { elementType: "labels.text.stroke", stylers: [{ color: labelStroke }] },
  { elementType: "labels.text.fill", stylers: [{ color: labelFill }] },
  { elementType: "labels.icon", stylers: [ { visibility: "off"  }]},
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: administrativeTextFill }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: poiTextFill }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: poiParkGeometry }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: poiParkTextFill }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: roadGeometry }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: roadGeometryStroke }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: roadTextFill }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: roadHighwayGeometry }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: roadHighwayGeometryStroke }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: roadHighwayTextFill }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: transitGeometry }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: transitStationTextFill }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: waterGeometry }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: waterTextFill }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: waterTextStroke }],
  },
]
